import React, { useEffect } from "react";
import Select, { default as ReactSelect } from "react-select";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import searchIcon from "@/assets/images/png/search-icon.png";
import { useSelector, useDispatch } from "react-redux";
import { selectFormattedCountries } from "@/store/modern/slices/countrySlice";
import defaultValues from "@/constant/defaultValues";
import { getFilteredInquiries } from "@/store/modern/slices/inquirySlice";
import { useState } from "react";
import RegistrationPopup from "@/components/RegistrationPopup";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { useNavigate } from "react-router-dom";
// import NoInquiriesFound from "@/assets/images/png/no-inquiries-found.png"
import no_data_found from "@/assets/images/svg/no_data_found.svg";
import { truncate } from "lodash";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import { Link } from "react-router-dom";

import OpenBedge from "@/assets/images/svg/open-icon.svg";
import FinishBedge from "@/assets/images/svg/finished-icon.svg";
import CloseBedge from "@/assets/images/svg/close-icon.svg";
import InProgressBedge from "@/assets/images/svg/inprogress-icon.svg";

import ShipIcon from "@/assets/images/svg/ship-icon.svg";
import PlanIcon from "@/assets/images/svg/plan-icon.svg";
import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";
import { motion } from "framer-motion";


const Index = () => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const countries = useSelector(selectFormattedCountries);
  const freightTypeList = defaultValues.FREIGHT_TYPE;
  const { filtered, loading } = useSelector((state) => state.inquiries);
  const [showLoader, setShowLoader] = useState(false);

  const [filters, setFilters] = useState({
    destination_country: null,
    origin_country: null,
    freight_type: null,
    commodity: null,
  });

  const [smallmodalShow, setSmallModalShow] = useState(false);

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  /* useEffect(() => {
    dispatch(getFilteredInquiries({}));
  }, [dispatch]); */

  const handleChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value?.value || null }));
  };

  const handleRegisterBtnClick = () => {
    nav(publicRoutePaths.REGISTRATION.path);
  }

  const handleCommodityInputChange = (e) => {
    setFilters((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value
      }
    });
  }

  const handleViewClick = (e) => {
    setSmallModalShow(true);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowLoader(true);
    try {
      dispatch(getFilteredInquiries(filters));
    } catch (err) {
      console.error("Error fetching data:", err);

    } finally {
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    }

  };

  const stripHTML = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

 useEffect(() => {
  const defaultFilters = {
    destination_country: null,
    origin_country: "United States",  
    freight_type: null,
    commodity: null,
  };
  setFilters(defaultFilters);            
  dispatch(getFilteredInquiries(defaultFilters));  
}, []);

  return (
    <>
      <section className="view-all-inquiries">
        <SeoHelmet
          title={seoConfig.inquiry.title}
          description={seoConfig.inquiry.description}
          keywords={seoConfig.inquiry.keywords}
          author={seoConfig.inquiry.author}
        />
        {showLoader && <ScreenLoaderHome />}
        {/* inner banner wrape START  */}
        <div className="inner-banner">
          <div className="container">
            <div className="content-wrape desk-hide">
              <h2>
                <motion.span className="light animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >View</motion.span>
                <motion.span className="blue-text animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > All</motion.span>
                <motion.span className="black animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Inquiries</motion.span>
              </h2>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Stay connected with every opportunity-manage all inquiries effortlessly.</motion.p>
            </div>
          </div>
        </div>
        {/* inner banner wrape END  */}

        {/* inner page content START */}
        <div className="inner-page-content-wrape view-all-inquiries-wrape">
          <div className='container'>
            <div className="content-wrape mobile-show page-head py-5">
              <h2 className="mobile-head-text">
                <motion.span className="light animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >View</motion.span>
                <motion.span className="blue-text animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > All</motion.span>
                <motion.span className="black animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Inquiries</motion.span>
              </h2>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Stay connected with every opportunity-manage all inquiries effortlessly.</motion.p>
            </div>
            <motion.div className="find-parter-wrape animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >
              <div className="inner">
                <div className="head">
                  <h3>VIEW ALL INQUIRIES</h3>
                </div>
                <div className="body">
                  <form onSubmit={handleSubmit}>
                    <div className="form-section">
                      <div className="container">
                        <div className="row">
                          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-12">
                            <div className="input-wrape">
                              <div className="input-pad select-wrape">
                                <Select
                                  className="select"
                                  placeholder="Select origin country"
                                  options={countries}
                                  classNamePrefix={"Drop-down-menu"}
                                  noOptionsMessage={() => "No origin country found"}
                                  menuPlacement="bottom"
                                  onChange={(val) => handleChange("origin_country", val)}
                                  isClearable
                                  value={countries.find((c) => c.value === filters.origin_country) || null} 
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-12">
                            <div className="input-wrape">
                              <div className="input-pad select-wrape">
                                <Select
                                  className="select"
                                  options={countries}
                                  placeholder="Select destination country"
                                  classNamePrefix={"Drop-down-menu"}
                                  noOptionsMessage={() => "No destination country found"}
                                  menuPlacement="bottom"
                                  onChange={(val) => handleChange("destination_country", val)}
                                  isClearable
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-12">
                            <div className="input-wrape">
                              <div className="input-pad select-wrape">
                                <Select
                                  className="select"
                                  options={freightTypeList}
                                  placeholder="Select freight type"
                                  classNamePrefix={"Drop-down-menu"}
                                  noOptionsMessage={() => "No freight type found"}
                                  menuPlacement="bottom"
                                  onChange={(val) => handleChange("freight_type", val)}
                                  isClearable
                                />
                              </div>

                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-12">
                            <div className="input-wrape">
                              <div className="input-pad">
                                <input
                                  type="text"
                                  className="input"
                                  name="commodity"
                                  placeholder="Enter commodity"
                                  value={filters.commodity}
                                  autoComplete="off"
                                  onChange={handleCommodityInputChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button type="submit" className="btn icon-btn-primary">
                        <img src={searchIcon} alt="search" className="" />
                        Search
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </motion.div>

            <div className="table-wrape">
              {loading && <p className="text-center">Loading...</p>}

              {!loading && filtered?.length > 0 && (
                <>
                  <br />
                  <h2 className="head">Total Inquiry</h2>
                  <p>View, filter, and respond to all inquiries from verified global partners.</p>
                  <br />

                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="">
                        <tr>
                          <th>Sr. No.</th>
                          <th>POL</th>
                          <th>POD</th>
                          <th>Type</th>
                          <th>Content</th>
                          <th>Status</th>
                          <th>Post Date</th>
                          <th>Valid Until</th>
                          <th>More Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filtered.map((inq, ikey) => (
                          <tr key={inq.id}>
                            <td>{ikey + 1}</td>
                            <td>{inq.country_from || "-"}</td>
                            <td>{inq.country_to || "-"}</td>
                            <td>
                              {/* {inq.freight_type || "-"} */}
                              {inq.freight_type === "Ocean" && <span className="round"><img src={ShipIcon} alt="" className="freight-type" /> </span>}
                              {inq.freight_type === "Air" && <span className="round"><img src={PlanIcon} alt="" className="freight-type" /> </span>}
                            </td>
                            <td>
                              {inq.message ? truncate(stripHTML(inq.message), {
                                'length': 312,
                                'omission': "..."
                              }) : "-"}
                            </td>
                            <td>
                              {inq.status === 0 && <img src={OpenBedge} alt="" className="status" />}
                              {inq.status === 1 && <img src={InProgressBedge} alt="" className="status" />}
                              {inq.status === 2 && <img src={FinishBedge} alt="" className="status" />}
                              {inq.status === 3 && <img src={CloseBedge} alt="" className="status" />}
                            </td>
                            <td>{inq.created_at ? new Date(inq.created_at).toLocaleDateString() : "-"}</td>
                            <td>{inq.validity_date ? new Date(inq.validity_date).toLocaleDateString() : "-"}</td>
                            <td>
                              <div className="btn outline small" onClick={handleViewClick}>
                                Respond
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {filtered?.length >= 10 && (
                    <div className="bottom-control-wrape">
                      <div className="pagination-wrape">
                        <a href="javascript:void(0)" title="" className="prev"></a>
                        <a href="javascript:void(0)" title="" className="number" style={{ color: "#ffffff", background: "#0b4471" }}>1</a>
                        <a href="javascript:void(0)" onClick={handleViewClick} title="" className="number">2</a>
                        <a href="javascript:void(0)" onClick={handleViewClick} title="" className="number">3</a>
                        <a href="javascript:void(0)" onClick={handleViewClick} title="" className="number">4</a>
                        <a href="javascript:void(0)" onClick={handleViewClick} title="" className="number">..</a>
                        <a href="javascript:void(0)" onClick={handleViewClick} title="" className="next"></a>
                      </div>
                      <div className="page-count-wrape">
                        {/* {filtered?.length < 10 
                    ? `1-${filtered?.length} of 1359`
                    : `1-10 of 1359`} */}
                        1-10 of 1359
                      </div>
                    </div>
                  )}

                </>
              )}

              {!loading && filtered?.length === 0 && <div className="no-data"><img src={no_data_found} alt='No inquiries found.' /></div>}
            </div>
          </div>
        </div>
        {/* inner page content END */}

        {smallmodalShow && (
          <RegistrationPopup
            title=""
            smallmodalShow={smallmodalShow}
            setSmallModalShow={setSmallModalShow}
            onSubmit={handleRegisterBtnClick}
            okButtonLabel="REGISTER NOW"
          >
            <div className="new-pop">
              <div className="img-wrape"></div>
              <div className="detail-wrape">
                <div className="inner">
                  <h5 className="registor-now">Grow With Us!</h5>
                  <h6>Register now to get more benefits!</h6>
                  <p className="registor-now-text">
                    Access special features, get personalized recommendations and connect with a growing community.
                  </p>
                  <Link to={publicRoutePaths.REGISTRATION.path} className="btn secondry-btn" target="_blank" href={publicRoutePaths.REGISTRATION.path} >Register Now</Link>
                </div>
              </div>
            </div>
          </RegistrationPopup>
        )}
      </section>
      <ConsentManager data={""} />
    </>
  );
};

export default Index;
